import type { ReactNode } from "react";
import { BottomNav } from "./BottomNav";

export function Layout({ children }: { children: ReactNode }) {
  return (
    <div className="flex min-h-screen flex-col bg-[#FAF6EE] bg-[radial-gradient(ellipse_at_top,_rgba(251,191,36,0.12),_transparent_65%)] text-[#2C221E]">
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-20 focus:rounded-lg focus:bg-[#2D2338] focus:px-4 focus:py-2 focus:text-amber-100"
      >
        Zum Inhalt springen
      </a>
      <div className="bg-gradient-to-r from-[#2D2338] via-[#3B2A4A] to-[#2D2338] px-4 py-1.5 text-center text-[11px] font-semibold tracking-wider text-amber-200/90 shadow-sm">
        ✦ Zauberbuch-Atelier · Handgefertigte Geschichten &amp; Illustrationen ✦
      </div>
      <BottomNav />
      <main
        id="main-content"
        className="mx-auto w-full max-w-4xl flex-1 px-4 pb-24 pt-6 md:pb-10"
      >
        {children}
      </main>
      <footer className="border-t border-amber-200/80 bg-[#FDF9F1] px-4 py-4 text-center text-xs text-[#6E5648]">
        <span className="font-serif italic text-[#2C221E]">✦ Zauber.app ✦</span>{" "}
        — Verträumte Kinderbuch-Manufaktur (Testbetrieb)
      </footer>
    </div>
  );
}
